<template>
  <h2 class="display-2 text-center mt-4 text-secondary">Latest News</h2>
  <ul class="text-body-1 pl-6">
    <li><strong>May 2025 - Version 1.1 Released! ✨</strong><br />
      Including updated characteristics for over 700 planets, beta version of visualization tools and holoexplorer game.</li>
    <li><strong>February 2025 - Tool of the Week on Wikidata! 🎉</strong><br />
      The Holonet Galactic Encyclopedia has been recognized as "Tool of the Week" by @wikidata! 🚀 
      <a href="https://m.wikidata.org/wiki/Wikidata:Status_updates/2025_02_03" target="_blank">Read the news here</a></li>
    <li><strong>January 2025 - Version 1.0 Released! ✨</strong><br />
      The Holonet Galactic Encyclopedia is live! Explore an initial dataset of planets from Wikidata, a functional UI,
      and a powerful search feature to navigate the galaxy. More updates coming soon! 🌌</li>
  </ul>
</template>

<script>
export default {
  name: "News",
};
</script>

<style scoped></style>